import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Input, Alert } from '@dreamtree-org/twreact-ui';
import { errorText } from '@/lib/format';
import { useMutation } from '@/lib/useQuery';
import { VendorAuthFrame } from './SignIn';

/**
 * Forgot password (MERCH-107). The server answers the same whether or not the
 * email has an account and emails a reset link that works once, for 1 hour.
 */
export default function ForgotPassword({ store }) {
  const forgot = useMutation('vendorForgotPassword');
  const [email, setEmail] = useState('');
  const [done, setDone] = useState('');
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const r = await forgot.run({ email });
      setDone((r.data && r.data.message) || 'Check your email for a link to set a new password.');
    } catch (ex) {
      setError(errorText(ex));
    }
  };

  return (
    <VendorAuthFrame store={store} title="Forgot password" subtitle="We will email you a link to set a new password.">
      {done ? (
        <Alert variant="success" title="Check your email">{done}</Alert>
      ) : (
        <form className="space-y-3" onSubmit={submit}>
          <Input label="Email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />
          {error ? <Alert variant="error" title="Could not send the link">{error}</Alert> : null}
          <Button type="submit" className="w-full" loading={forgot.loading}>Email me a link</Button>
        </form>
      )}
      <p className="text-sm text-center opacity-80"><Link className="font-medium underline" to="/login">Back to sign in</Link></p>
    </VendorAuthFrame>
  );
}
